import startsWith from "lodash/startsWith";
import urlToBase64 from "./urlToBase64";
export default (imgSrc, imgWidth, imgHeight, mimeType, abortController) => new Promise(resolve => {
    if (!imgSrc || (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted)) {
        resolve(null);
        return;
    }
    const tempImg = new Image();
    tempImg.onload = () => {
        if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) {
            resolve(null);
            return;
        }
        const width = imgWidth || tempImg.width;
        const height = imgHeight || tempImg.height;
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        try {
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(tempImg, 0, 0, tempImg.width, tempImg.height, 0, 0, width, height);
            if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) {
                resolve(null);
                return;
            }
            const dataURL = canvas.toDataURL(mimeType);
            resolve(dataURL);
        }
        catch (ex) {
            console.warn(ex);
            resolve(null);
        }
    };
    tempImg.onerror = () => {
        resolve(null);
    };
    tempImg.onabort = () => {
        resolve(null);
    };
    if (startsWith(imgSrc, window.location.origin) || startsWith(imgSrc, "/")) {
        tempImg.src = imgSrc;
    }
    else {
        urlToBase64(imgSrc, (res) => {
            if (!res)
                resolve(null);
            else
                tempImg.src = res;
        });
    }
});
